import Alpine from "alpinejs";
import "./scripts/scripts.ts";
import "./styles/index.scss";

(window as any).Alpine = Alpine;

Alpine.start();
